import React, { useEffect, useState } from 'react';

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function isInStandaloneMode() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

export default function InstallPWAButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [showIOSHint, setShowIOSHint] = useState(false);
  const [iosEligible, setIosEligible] = useState(false);

  useEffect(() => {
    if (isInStandaloneMode()) {
      setInstalled(true);
      return;
    }

    if (isIOS()) {
      setIosEligible(true);
      return;
    }

    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const handleAppInstalled = () => {
      setInstalled(true);
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    if (iosEligible) {
      setShowIOSHint(true);
      return;
    }
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setInstalled(true);
    }
    setDeferredPrompt(null);
  };

  if (installed) return null;
  if (!iosEligible && !deferredPrompt) return null;

  return (
    <>
      <button className="pwa-install-btn" onClick={handleInstallClick}>
        📲 Install App
      </button>

      {showIOSHint && (
        <div className="pwa-ios-overlay" onClick={() => setShowIOSHint(false)}>
          <div className="pwa-ios-box" onClick={(e) => e.stopPropagation()}>
            <button className="pwa-ios-close" onClick={() => setShowIOSHint(false)}>✕</button>
            <p className="pwa-ios-title">Install Saskara Record di iPhone</p>
            <ol className="pwa-ios-steps">
              <li>Ketuk ikon <strong>Bagikan</strong> <span className="pwa-ios-icon">⬆️</span> di bar bawah Safari</li>
              <li>Scroll dan pilih <strong>"Tambah ke Layar Utama"</strong> (Add to Home Screen)</li>
              <li>Ketuk <strong>"Tambah"</strong> di pojok kanan atas</li>
            </ol>
            <p className="pwa-ios-note">Setelah itu, ikon Saskara Record akan muncul di home screen kamu seperti aplikasi biasa.</p>
          </div>
        </div>
      )}
    </>
  );
}
